import React from 'react';
import Responsive from 'react-responsive';
import { DESKTOP_BREAKPOINT_MIN } from '../../../config/consts';

const Desktop = props => <Responsive {...props} minWidth={DESKTOP_BREAKPOINT_MIN} />;

export default Desktop;
